import { LOGIN, LOGOUT, SET_USER, SET_USER_TYPE,SET_ACCESS, CLIENT_FILTER, SITE_FILTER, SET_CLIENT_OPTIONS, SET_SITE_OPTIONS} from '../actions'

const clientFilterHandler = (state, value) => {
    return {...state, selectedClientID: value}
}

const siteFilterHandler = (state, value) => {
    return {...state, selectedSiteID: value}
}

const AppReducer = (state, action) => {
    switch (action.type) {
        case LOGIN:
            return { ...state, isLoggedIn: true }
        case LOGOUT:
            return { 
                ...state, 
                isLoggedIn: false, 
                selectedClientID: null, 
                selectedSiteID: null
            }
        case SET_USER:
            return { ...state, user: { ...action.payload } }
        case SET_USER_TYPE:
            return { ...state, type: action.payload }
        case SET_ACCESS:
            return{...state, access:action.payload}
        case CLIENT_FILTER:
            return clientFilterHandler(state, action.payload.id)
        case SITE_FILTER:
            return siteFilterHandler(state, action.payload.id)
        case SET_CLIENT_OPTIONS:
            return { ...state, client_options: action.payload }
        case SET_SITE_OPTIONS:
            return { ...state, site_options: action.payload }
        default:
            return { ...state }
    }
}

export default AppReducer